import { writable } from "svelte/store";
export const currentPage = writable("Home");
export const currentUser = writable(null);
export const currentLesson = writable(0);
export const statsData = writable([]);
export const currentTyped = writable([]);
export const currentTimes = writable({});
export const currentErr = writable({});
export const currentText = writable(`#import <stdio.h>

void bubblesort(int*,int);
void printarr(int*,int);

int main(){
	printf("Bubble sort\\n");
	int arr[3]={3,2,1};
	printarr(arr,3);
	bubblesort(arr,3);
	printarr(arr,3);
	printf("\\n");
	return 0;
}

void bubblesort(int* arr,int length){
	for(int i=0;i<length;i++){
		for(int j=0;j<length-1;j++){
			if(arr[j]>arr[j+1]){
				int temp = arr[j];
				arr[j] = arr[j+1];
				arr[j+1] = temp;
			}
		}
	}
}

void printarr(int *arr,int length){
	for(int i=0;i<length;i++){
		printf("%d->",arr[i]);
	}
	printf("\\n");
}
`);
